module.exports = __webpack_public_path__ + "static/media/DSC_0010.e7366447.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0010.jpg
// module id = 675
// module chunks = 0